import { useSearchParams } from 'react-router-dom';

import { useVenuesRegionScope } from './use-venues-region-scope';
import { useVenueRoster } from './venues-roster-api';
import { scopeOf } from './venues-scope';

/**
 * What the Venues page reads from the address and the roster: the region scope,
 * the open-tasks filter (`?tasks=open`) and the roster itself. The roster is
 * held back until the viewer's default region is known, so a Regional Director
 * never sees a national roster flash up first.
 */
export function useVenuesRosterView() {
  const [params, setParams] = useSearchParams();
  const regionScope = useVenuesRegionScope();
  const tasksOnly = params.get('tasks') === 'open';
  const roster = useVenueRoster(
    { regions: regionScope.regions, hasOpenTasks: tasksOnly },
    !regionScope.pending,
  );

  const setTasksOnly = (on: boolean) => {
    const next = new URLSearchParams(params);
    if (on) next.set('tasks', 'open');
    else next.delete('tasks');
    setParams(next, { replace: true });
  };

  return {
    ...roster,
    regionScope,
    tasksOnly,
    setTasksOnly,
    scope: scopeOf(roster.data, regionScope.regions),
    /** The viewer is on the union of their own several regions. */
    isOwnRegions: !regionScope.pending && regionScope.regions.length > 1,
  };
}
